module.exports = __webpack_public_path__ + "static/other/organize_desk_game_desk_5.5beba22f.json";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/maps/organizeDeskGame/organize_desk_game_desk_5.json
// module id = 2353
// module chunks = 0